// Translations
import { EXCEPTION_BAD_REQUEST, EXCEPTION_INIT, EXCEPTION_SAME_PAGE_TRACKED } from './translations/tracking.translations';
// Constants
import { COMMON_KEYS, MAX_ATTEMPTS, TIME_TO_RETRY } from './constants/tracking.constants';
// Types
import { TrackingEventsEnum, } from '@openbank/cf-ui-static-data';
let TrackingInstance;
class Tracking {
    constructor(userId, userStatus, userType) {
        this.trackLinkEvent = ({ payload, pathname }) => this.track({
            type: TrackingEventsEnum.LINK,
            payload: {
                ...this.mandatoryFields,
                ...payload,
                ...(pathname ? { pathname } : {}),
            },
        });
        this.trackViewEvent = ({ payload, sessionId, error }) => this.track({
            type: TrackingEventsEnum.VIEW,
            payload: {
                ...this.mandatoryFields,
                ...payload,
                ...(sessionId ? { sessionId } : {}),
                ...(error ? { ...error } : {}),
            },
        });
        this.trackEvent = () => ({
            track: (action) => this.track({
                ...action,
                payload: {
                    ...this.mandatoryFields,
                    ...action?.payload,
                },
            }),
        });
        this.trackingHandlers = () => ({
            trackLinkEvent: ({ payload, pathname }) => this.trackLinkEvent({ payload, pathname }),
            trackErrorEvent: ({ payload, error }) => this.trackViewEvent({ payload, error }),
            trackViewEvent: ({ payload, sessionId }) => this.trackViewEvent({ payload, sessionId }),
        });
        this.currentPageDisplayed = '';
        this.startAttempts = 0;
        this.mandatoryFields = {
            ...(userId ? { userID: userId } : {}),
            userStatus,
            userType,
        };
    }
    trackViewEventType(payload) {
        if (payload?.pageName !== this.currentPageDisplayed) {
            this.currentPageDisplayed = payload.pageName;
            window?.utag?.view(payload);
            return;
        }
        window.console.warn(EXCEPTION_SAME_PAGE_TRACKED);
    }
    trackLinkEventType(payload) {
        window?.utag?.link({ ...payload, eventCategory: this.currentPageDisplayed });
    }
    dispatchEvent({ payload, type }) {
        switch (type) {
            case TrackingEventsEnum.VIEW:
                this.trackViewEventType(payload);
                break;
            case TrackingEventsEnum.LINK:
            default:
                this.trackLinkEventType(payload);
                break;
        }
    }
    isValidSetup({ payload, type }) {
        return type && payload && COMMON_KEYS.every((k) => payload[k]);
    }
    checkToSetupWindowTools(action) {
        if (this.startAttempts === MAX_ATTEMPTS) {
            window.console.error(EXCEPTION_INIT);
            return;
        }
        this.startAttempts += 1;
        setTimeout(() => this.track(action), TIME_TO_RETRY);
    }
    checkActionAndDispatchEvent(action) {
        if (!this.isValidSetup(action)) {
            window.console.error(EXCEPTION_BAD_REQUEST);
            return;
        }
        this.dispatchEvent(action);
    }
    track(action) {
        if (!window.utag) {
            this.checkToSetupWindowTools(action);
            return;
        }
        this.checkActionAndDispatchEvent(action);
    }
}
const getTrackingInstance = ({ userId, userStatus, userType }) => {
    if (!TrackingInstance) {
        TrackingInstance = new Tracking(userId, userStatus, userType);
    }
    return TrackingInstance;
};
export { getTrackingInstance };
//# sourceMappingURL=index.js.map